var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8833 0H5.11668C2.30024 0 0 2.30699 0 5.1317V14.8683C0 17.7021 2.30024 20 5.11668 20H20.8833C23.7088 20 26 17.693 26 14.8683V5.1317C26 2.29791 23.6998 0 20.8833 0ZM24.1797 4.99546H7.05469V1.81653H20.8833C22.6583 1.81653 24.1073 3.23342 24.1797 4.99546ZM1.81122 14.8683V5.1317C1.81122 3.30609 3.29641 1.81653 5.11668 1.81653H5.24347V18.1835H5.11668C3.29641 18.1835 1.81122 16.6939 1.81122 14.8683ZM20.8833 18.1835H7.05469V6.81199H24.1978V14.8683C24.1978 16.6939 22.7126 18.1835 20.8924 18.1835H20.8833Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/Layout.1ec02ca161ed96a99b1eb5fa23715ca3.svg";
export { ForwardRef as ReactComponent };